var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Slider'),_c('Main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }